import moment from "moment";
import React from "react";

interface IDateTimeProps {
  date: any;
  useNewLine?: boolean;
  format?: string;
}

const DateTime = ({
  date,
  useNewLine,
  format = "MM/DD/YY, HH:mm",
}: IDateTimeProps) => {
  const dtString = moment(date).format(format);
  const parts = dtString.split(", ");

  return useNewLine ? (
    <>
      {parts[0]}
      <br />
      {parts[1]}
    </>
  ) : (
    <>{dtString}</>
  );
};

export default DateTime;
